import styled from 'styled-components';
import { RouterLink as DefaultRouterLink } from '@redux-first-router-link';

import { buttonCSS } from '@simplywallst/ui-core';

import type { ButtonProps } from '@simplywallst/ui-core';

export const ListItem = styled('li')`
  margin-bottom: 12px;
`;

export const RouterLink = styled(DefaultRouterLink)<ButtonProps>`
  ${buttonCSS}
  text-align: center;
`;
